// El aviso de la campana de un encargo (recibido, hecho, «no puedo», comentario) lleva en `type`
// "encargo:<id del encargo>" (lo crea backend/lib/encargosDb.js). De ahi sale el hilo al que lleva el aviso.
export function idEncargoDeAviso(type) {
  const m = /^encargo:(\d+)$/.exec(String(type || ""));
  return m ? m[1] : null;
}
